import { useTranslation } from "react-i18next";
import PageHeader from "@/shared/components/layout/dashboard-layout/page-header.tsx";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/ui/components/ui/card";
import { Button } from "@/ui/components/ui/button";
import { Input } from "@/ui/components/ui/input";
import { Label } from "@/ui/components/ui/label";
import { useOrganizationStore } from "@/shared/stores/useOrganizationStore";
import { useGetOrganizations } from "@/auth/api/queries/user.queries";
import { Skeleton } from "@/ui/components/ui/skeleton";

const OrganizationSettings = () => {
  const { t } = useTranslation("settings");
  const { selectedOrganizationId } = useOrganizationStore();
  const { data: orgsData, isLoading } = useGetOrganizations();

  const organization = orgsData?.data?.find(org => org.id === selectedOrganizationId);

  const breadcrumbs = [
    {
      path: "/",
      breadcrumb: organization?.name || t("breadcrumbs.organization"),
    },
    {
      path: "/settings/organization",
      breadcrumb: t("breadcrumbs.settings"),
    },
  ];

  if (isLoading) {
    return (
      <div className="h-full">
        <PageHeader breadcrumbs={breadcrumbs} />
        <div className="p-6 space-y-6">
          <Skeleton className="h-64 w-full" />
        </div>
      </div>
    );
  }

  if (!organization) {
    return (
      <div className="h-full">
        <PageHeader breadcrumbs={breadcrumbs} />
        <div className="p-6">
          <p className="text-muted-foreground">{t("organization.empty")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full">
      <PageHeader breadcrumbs={breadcrumbs} />
      <div className="p-6 space-y-6 max-w-4xl">
        <div>
          <h1 className="text-2xl font-bold">{t("organization.title")}</h1>
          <p className="text-muted-foreground">
            {t("organization.description")}
          </p>
        </div>

        {/* Basic Information */}
        <Card>
          <CardHeader>
            <CardTitle>{t("organization.basicTitle")}</CardTitle>
            <CardDescription>
              {t("organization.basicDescription")}
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="org-name">{t("organization.nameLabel")}</Label>
              <Input
                id="org-name"
                defaultValue={organization.name}
                placeholder={t("organization.namePlaceholder")}
              />
            </div>
          </CardContent>
        </Card>

        {/* Branding */}
        {/*<Card>
          <CardHeader>
            <CardTitle>Branding</CardTitle>
            <CardDescription>
              Company logo used on reports
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="logo">Company Logo</Label>
              <div className="flex items-center gap-4">
                <div className="h-24 w-24 border-2 border-dashed rounded-md flex items-center justify-center bg-muted">
                  <Upload className="h-8 w-8 text-muted-foreground" />
                </div>
                <Button variant="outline">
                  <Upload className="h-4 w-4 mr-2" />
                  Upload Logo
                </Button>
              </div>
              <p className="text-sm text-muted-foreground">
                Recommended: PNG or SVG, max 2MB
              </p>
            </div>
          </CardContent>
        </Card>*/}

        {/* Locations Management */}
        {/* <Card>
          <CardHeader>
            <CardTitle>Locations</CardTitle>
            <CardDescription>
              Manage locations (sites) under this organization
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              Add Location
            </Button>
          </CardContent>
        </Card>*/}

        {/* Save Button */}
        <div className="flex justify-end gap-3">
          <Button variant="outline">{t("actions.cancel")}</Button>
          <Button>{t("actions.saveChanges")}</Button>
        </div>
      </div>
    </div>
  );
};

export default OrganizationSettings;
